import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';

import Home from './pages/home';

import Devices from './pages/devices';
import DeviceProfile from './pages/deviceProfile';
import DeviceAppUpdate from './pages/deviceAppUpdate';

import Properties from './pages/properties';
import PropertyAdd from './pages/propertyAdd';
import PropertyUpdate from './pages/propertyUpdate';

import UserLogin from './pages/userLogin';
import Users from './pages/users';
import UserAdd from './pages/userAdd';
import UserUpdate from './pages/userUpdate';
import UserProfile from './pages/userProfile';
import UserChangePassword from './pages/userChangePassword';
import UserResetPassword from './pages/userResetPassword';
import UserForgotPassword from './pages/userForgotPassword';
import UserActivity from './pages/userActivity';

import PolicyAdd from './pages/policyAdd';
import PolicyUpdate from './pages/policyUpdate';

import GroupAdd from './pages/groupAdd';
import GroupUpdate from './pages/groupUpdate';

import Page404 from './pages/page404';

import { getToken, getAdmin } from './services/LocalStorageService';


// ----------------------------------------------------------------------

export default function Router() {

  const routes = useRoutes( getToken()===null ? [
      {
        path: '/',
        children: [
          { element: <Navigate to="/login" />, index: true },
          { path: '/login', element: <UserLogin /> },
          { path: '/cloud/reset-password', element: <UserResetPassword /> },
          { path: '/cloud/forgot-password', element: <UserForgotPassword /> },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/login" replace />,
      },
  ]:[
      {
        path: '/',
        element: <DashboardLayout />,
        children: [
          // home page
          { element: <Navigate to="/cloud/home" />, index: true },
          { path: '/cloud/home', element: <Home /> },
          { path: '/cloud/devices', element: <Devices /> },
          { path: '/cloud/device-profile', element: <DeviceProfile /> },
          { path: '/cloud/device-app-update', element: <DeviceAppUpdate /> },

          // property management
          { path: '/cloud/properties', element: <Properties /> },
          { path: '/cloud/add-property', element: <PropertyAdd /> },
          { path: '/cloud/update-property', element: <PropertyUpdate /> },

          // user management
          { path: '/cloud/user-profile', element: <UserProfile /> },
          { path: '/cloud/activity', element: <UserActivity /> },
          { path: '/cloud/change-password', element: <UserChangePassword /> },
          { path: '/cloud/forgot-password', element: <UserForgotPassword /> },
          { path: '/cloud/reset-password', element: <UserResetPassword /> },
          { path: '/cloud/users', element: <Users /> },
          { path: '/cloud/add-user', element: <UserAdd /> },
          { path: '/cloud/update-user', element: <UserUpdate /> },

          // policy management
          { path: '/cloud/add-policy', element: <PolicyAdd /> },
          { path: '/cloud/update-policy', element: <PolicyUpdate /> },

          // group management
          { path: '/cloud/add-group', element: <GroupAdd /> },
          { path: '/cloud/update-group', element: <GroupUpdate /> },

        ],
      },
      {
        element: <SimpleLayout />,
        children: [
          { element: <Navigate to="/home" />, index: true },
          { path: '404', element: <Page404 /> },
          { path: '*', element: <Navigate to="/404" /> },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/404" replace />,
      },
  ]);

  return routes;
}
